/**
 * @public
 */
export type IconSize = 'x-small' | 'small' | 'medium' | 'large';
